export enum SportType {
  Football = "football",
  Handball = "handball",
}
